<template>
  <!--新建案例页面步骤条-->
    <el-steps :active="active" finish-status="success" simple class="steps">
      <el-step title="总体信息" ></el-step>
      <el-step title="环境信息" ></el-step>
      <el-step title="道路信息" ></el-step>
      <el-step title="参与方信息" ></el-step>
    </el-steps>
</template>

<script>
  import bus from './bus'

    export default {
        name: "newCase_steps",
        data(){
          return{
            active:0
          }
        },
      methods:{
        stepOne(){
          this.active = 0;
          bus.$emit('envLast', 0);
        },
        stepTwo(){
          this.active = 1;
          bus.$emit('activeTotal', 1);
        },
        stepThree(){
          this.active = 2;
          bus.$emit('envNext', 2);
        },
        stepFour(){
          this.active = 3;
          bus.$emit('roadNext', 3);
        },
      },
      created(){
        // 总体信息单击下一步
        bus.$on('activeTotal', msg => {
          this.active = msg;
        });
        // 环境信息单击下一步
        bus.$on('envNext', msg => {
          this.active = msg;
        });
        // 环境信息单击上一步
        bus.$on('envLast', msg => {
          this.active = msg;
        });
        // 道路信息单击下一步
        bus.$on('roadNext', msg => {
          this.active = msg;
        });
        // 道路信息单击上一步
        bus.$on('roadLast', msg => {
          this.active = msg;
        });
        // 参与方信息单击上一步
        bus.$on('parLast', msg => {
          this.active = msg;
        });
        // 参与方信息单击下一步
        bus.$on('parNext', msg => {
          this.active = msg;
        });
      }
    }
</script>

<style scoped>
.steps{
  width: 82%;
  height: 3%;
  margin-top: 1%;
  /*cursor: pointer;*/
}
</style>



// WEBPACK FOOTER //
// src/data/newCase_steps.vue